import React from "react";
import { useOrganisation } from "../contexts/OrganisationContext";
import TesterReports from "./TesterReports";
import ReviewerReports from "./ReviewerReports";

/**
 * Role switch for the /testrapporter list: reviewers get the review-oriented
 * list, everyone else (testers) get their own reports.
 */
function TestReports() {
  const { activeRoleId } = useOrganisation();
  const isReviewer = activeRoleId === "inera-reviewer";
  return isReviewer ? <ReviewerReports /> : <TesterReports />;
}

export default TestReports;
